// parrain-navigation.service.ts
import { Injectable, inject } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { ParrainAnnonceService } from 'app/_services/parrain-annonce.service';
import { catchError, switchMap, map, of, EMPTY, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ParrainNavigationService {
  private router = inject(Router);
  private parrainAnnonceService = inject(ParrainAnnonceService);

  private navigate(commands: any[], extras?: NavigationExtras) {
    return this.router.navigate(commands, extras);
  }

  onShowParrainSpace(sponsorId: string) {
    return this.parrainAnnonceService
      .getParrainIdBySponsorId(sponsorId)
      .pipe(
        catchError((err) => {
          if (err?.status === 404) {
            // fallback direct
            this.navigate(['/partenaire-detail', sponsorId]);
            return EMPTY;
          }
          return throwError(() => err);
        }),
        switchMap((parrainId) => {
          if (!parrainId) {
            this.navigate(['/partenaire-detail', sponsorId]);
            return EMPTY;
          }
          return this.parrainAnnonceService
            .getAnnonceApprouveeByParrainId(parrainId)
            .pipe(
              map((annonce) => ({ parrainId, annonce })),
              catchError(() => of({ parrainId, annonce: null }))
            );
        })
      )
      .subscribe(({ parrainId, annonce }) => {
        if (annonce) {
          this.navigate(['/pub-parrain', annonce.id], {
            queryParams: { sponsorId },
          });
        } else {
          this.navigate(['/partenaire-detail', sponsorId]);
        }
      });
  }
}
